module.exports = __webpack_public_path__ + "static/media/About Us Picture 08.33c6a9a3.jpg";